module.exports = __webpack_public_path__ + "media/images/icons/Unicorn-f7331f666a43d05e10c977fa3d0e61b8.svg";